import { render, staticRenderFns } from "./header-account-button-cncc.vue?vue&type=template&id=1b55721f&scoped=true&"
import script from "./header-account-button-cncc.vue?vue&type=script&lang=js&"
export * from "./header-account-button-cncc.vue?vue&type=script&lang=js&"
import style0 from "./header-account-button-cncc.vue?vue&type=style&index=0&id=1b55721f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b55721f",
  null
  
)

export default component.exports